import { render } from "./MigrateTabsLayout.vue?vue&type=template&id=df592390&scoped=true&lang=pug"
import script from "./MigrateTabsLayout.vue?vue&type=script&lang=js"
export * from "./MigrateTabsLayout.vue?vue&type=script&lang=js"

import "./MigrateTabsLayout.vue?vue&type=style&index=0&id=df592390&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df592390"]])

export default __exports__